import { render, staticRenderFns } from "./AddFacebookCampaignAction.vue?vue&type=template&id=f031c8c2"
import script from "./AddFacebookCampaignAction.vue?vue&type=script&lang=js"
export * from "./AddFacebookCampaignAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports